<script lang="ts">
  // Activity name with the date and athlete under it, governed by the title/date/athlete fields.
  import type { ReportContext } from '../context'

  export let ctx: ReportContext
  export let size: 'md' | 'lg' | 'xl' = 'md'
  export let lines = 2

  $: a = ctx.data.activity
  $: meta = [ctx.show('date') ? ctx.fmt.date(a.date) : null, ctx.show('athlete') ? ctx.data.athlete.name : null].filter(Boolean)
</script>

{#if ctx.show('title') || meta.length}
  <div class="xr-title-block xr-{size}">
    {#if ctx.show('title')}
      <h1 class="xr-title" style="-webkit-line-clamp: {lines};">{a.name}</h1>
    {/if}
    {#if meta.length}
      <p class="xr-meta">{meta.join('  ·  ')}</p>
    {/if}
  </div>
{/if}

<style>
  .xr-title {
    font-family: var(--display);
    font-weight: 700;
    font-size: 64px;
    line-height: 1.02;
    letter-spacing: 0.005em;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    overflow-wrap: anywhere;
  }
  .xr-lg .xr-title {
    font-size: 80px;
  }
  .xr-xl .xr-title {
    font-size: 104px;
    line-height: 0.98;
  }
  .xr-meta {
    margin-top: 12px !important;
    font-size: 26px;
    font-weight: 500;
    color: var(--muted);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .xr-lg .xr-meta, .xr-xl .xr-meta {
    font-size: 28px;
  }
</style>
